module.exports = __webpack_public_path__ + "img/web-about-mission.f2f82b5c.png";